import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import AthensCoverageZone from "./sections/AthensCoverageZone";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <AthensCoverageZone />
      <Contact />
      <Footer />
    </div>;
}